<template>
    <Header></Header>
    <Transition>
        <main class="opui-main opui-pt-6">
            <div class="opui-container" v-if="loaded && template">
                <div class="optpl-details-container">
                    <a href="#" @click.prevent="$router.go(-1)" class="optpl-back"><i class="opui-fa opui-fa-arrow-left"></i> Go back</a>

                    <div class="optpl-details-card">
                        <a href="#" @click.prevent="toggleLike" class="optpl-template-like" :class="{ liked: template.liked }"><i class="opui-fa opui-fa-heart"></i></a>

                        <div class="optpl-details-card__info">
                            <div class="optpl-details-card__collections" v-if="template.collections">
                                <span v-for="collection in template.collections">{{ collection.title }}</span>
                            </div>
                            <h2>{{ template.title }}</h2>
                            <p>{{ template.description || '-' }}</p>

                            <!-- <p><small>{{ template.tier_ids }}</small></p> -->

                            <div class="optpl-details-card__tags-container">
                                <div class="optpl-details-card__tags" v-for="tagGroup in template.tags">
                                    <h3>{{ tagGroup.title }}</h3>
                                    <span v-for="tag in tagGroup.tags">{{ tag.title }}</span>
                                </div>
                            </div>

                            <div class="optpl-details-card__actions">
                                <a :href="template.preview_link" class="opui-btn opui-btn-outline" v-if="template.preview_link" target="_blank"><i class="opui-fa opui-fa-play-circle-o"></i> Live Preview</a>
                                <a href="#" class="opui-btn opui-btn-primary" @click.prevent="start" v-if="userHasTiers(template.tier_ids)">Start with this template</a>
                                <UpgradeButton v-else />
                            </div>
                        </div>

                        <div class="optpl-details-card__media" v-if="image">
                            <figure><img :src="image" alt="" /></figure>
                        </div>
                    </div>

                    <div class="optpl-details-related">
                        <div class="optpl-templates__container">
                            <div class="optpl-templates__group">
                                <RelatedTemplates :group="relatedTemplates" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DetailsAreLoading v-if="!loaded" />
        </main>
    </Transition>
</template>

<script>
import { useFiltersStore } from '../store/filters'
import { useTemplatesStore } from '../store/templates'
import { mapStores } from 'pinia'
import CreateNewPageModal from '../components/Templates/Modals/CreateNewPageModal.vue'
import Header from '../components/Global/Header.vue'
import Hero from '../components/Templates/Hero.vue'
import Filters from '../components/Templates/Filters.vue'
import RelatedTemplates from '../components/Templates/RelatedTemplates.vue'
import TemplateItem from '../components/Templates/TemplateItem.vue'
import Templates from '../components/Templates/Templates.vue'
import UpgradeButton from '../components/Templates/UpgradeButton.vue'
import DetailsAreLoading from '../components/Loading/DetailsAreLoading.vue'

export default {
    components: { CreateNewPageModal, Header, Hero, Filters, RelatedTemplates, TemplateItem, Templates, UpgradeButton, DetailsAreLoading },
    computed: {
        ...mapStores(useFiltersStore, useTemplatesStore),
    },
    data() {
        return {
            imageSrc: null,
            filtersStore: useFiltersStore(),
            templatesStore: useTemplatesStore(),
            relatedTemplates: {},
            templateUid: this.$route.params.uid,
            template: null,
            loaded: false,
        }
    },
    created() {
        this.loadInitialData()
    },
    mounted() {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'instant' })
        }, 10)
    },
    computed: {
        image() {
            this.imageSrc = ''

            if (this.template.preview) this.imageSrc = this.template.preview
            if (this.template.preview_full) this.imageSrc = this.template.preview_full

            // If we still have no imageSrc, use a placeholder
            if (!this.imageSrc) this.imageSrc = this.imgUrl('img-placeholder.webp')

            return this.imageSrc
        },
    },
    methods: {
        loadInitialData() {
            // Customer templates are loaded differently
            if (this.$route.name === 'customer-template') {
                this.$http
                    .get('/templates/' + this.templateUid + '?customer=1&stripData=true')
                    .then(async response => {
                        this.template = response.data.data
                        this.relatedTemplates = {
                            title: this.template.related.title || 'Related Templates',
                            items: this.template.related.templates,
                        }
                        this.loaded = true
                    })
                    .catch(error => {
                        this.$toast.error('Error when fetching your template.')
                        console.error(error)
                        this.loaded = true
                    })
            } else {
                this.$http
                    .get('/templates/' + this.templateUid + '?stripData=true')
                    .then(async response => {
                        this.template = response.data.data
                        this.relatedTemplates = {
                            title: this.template.related.title || 'Related Templates',
                            items: this.template.related.templates,
                        }
                        this.loaded = true
                    })
                    .catch(error => {
                        this.$toast.error('Error when fetching template.')
                        console.error(error)
                        this.loaded = true
                    })
            }
        },

        start() {
            if (this.template && this.template.uid) {
                this.$vfm.show({ component: CreateNewPageModal, bind: { template: this.template } })
            } else {
                alert('Template not found: ' + this.templateUid)
            }
        },

        toggleLike() {
            if (this.template.liked) {
                this.template.liked = false
                this.templatesStore.unlikeTemplate(this.template.uid)
            } else {
                this.template.liked = true
                this.templatesStore.likeTemplate(this.template.uid)
            }
        },
    },
}
</script>
